import script from "./ActionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionModal.vue?vue&type=script&setup=true&lang=js"

import "./ActionModal.vue?vue&type=style&index=0&id=cbf541ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cbf541ec"]])

export default __exports__